<template>
  <div class="df-empty-wrapper">
    <img :src="imgSrc" alt="" />
    <div class="empty-content">
      {{ text }}
    </div>
  </div>
</template>
<script>
import EmptyInfo from "./imgs/empty-info.png";
export default {
  name: "Empty",
  props: {
    src: String,
    content: String,
  },
  data() {
    return {
      imgSrc: this.src || EmptyInfo,
      text: this.content || "暂无数据",
    };
  },
};
</script>
<style scoped>
.df-empty-wrapper {
  margin-top: 120px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.df-empty-wrapper img {
  width: 260px;
}
.empty-content {
  font-size: 16px;
  font-weight: 400;
  color: #999999;
}
</style>
